export const GOOGLE_TAG_MANAGER_CONTAINER_ID = "GTM-TKMW3892";
